/* PURE LAB — collection filters.
   The panel collects a selection and applies it on demand, the way the reference does:
   the filtered page is fetched, the grid and the panel are swapped in, and the URL is
   updated so the result stays shareable. */
(function () {
  var form = document.getElementById('facet-form');
  if (!form) return;

  var drawer = document.getElementById('filters-drawer');
  var pending = null;

  function swap(html, url) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');

    var grid = document.getElementById('product-grid');
    var freshGrid = parsed.getElementById('product-grid');
    if (grid && freshGrid) grid.innerHTML = freshGrid.innerHTML;

    /* Counts and disabled states change with every selection. */
    var freshForm = parsed.getElementById('facet-form');
    if (freshForm) form.innerHTML = freshForm.innerHTML;

    var toolbar = document.querySelector('.collection-toolbar');
    var freshToolbar = parsed.querySelector('.collection-toolbar');
    if (toolbar && freshToolbar) toolbar.innerHTML = freshToolbar.innerHTML;

    var sentinel = document.getElementById('infinite-scroll-sentinel');
    var freshSentinel = parsed.getElementById('infinite-scroll-sentinel');
    if (sentinel && freshSentinel) {
      sentinel.setAttribute('data-next', freshSentinel.getAttribute('data-next') || '');
    } else if (sentinel) {
      sentinel.remove();
    }

    var nav = document.getElementById('pagination-nav');
    var freshNav = parsed.getElementById('pagination-nav');
    if (nav && freshNav) {
      nav.innerHTML = freshNav.innerHTML;
    } else if (nav) {
      nav.remove();
    }

    window.history.replaceState({}, '', url);
  }

  function apply(close) {
    var query = new URLSearchParams(new FormData(form));

    /* An untouched field would otherwise land in the URL as an empty parameter. */
    Array.from(query.keys()).forEach(function (key) {
      if (query.get(key) === '') query.delete(key);
    });

    var url = window.location.pathname + (query.toString() ? '?' + query.toString() : '');

    if (pending) pending.abort();
    pending = new AbortController();
    form.setAttribute('aria-busy', 'true');

    fetch(url, { signal: pending.signal })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        swap(html, url);
        if (close && drawer && typeof drawer.hide === 'function') drawer.hide();
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') window.location.href = url;
      })
      .finally(function () {
        form.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-facets-apply]')) {
      event.preventDefault();
      apply(true);
      return;
    }

    var clear = event.target.closest('[data-facets-clear]');
    if (clear) {
      event.preventDefault();
      form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        input.checked = false;
      });
      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        input.value = '';
      });
      apply(true);
    }
  });

  /* The slider drives the upper bound, as in the reference. */
  form.addEventListener('input', function (event) {
    var slider = event.target.closest('[data-price-range]');
    if (!slider) return;

    var max = form.querySelector('[data-price-max]');
    if (max) max.value = slider.value;
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    apply(true);
  });

  /* Enter inside a price field applies without reaching for the button. */
  form.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target.matches('input[type="number"]')) {
      event.preventDefault();
      apply(true);
    }
  });
})();
